import { StyleSheet } from 'react-native'
import { Scene } from '../../b.providers/ScenesProvider/Scenes'
import { Stats } from '@react-three/drei'
import SplashSceneElements from './SplashSceneElements'

const SplashScene = () => {
  return (
    <Scene // alias for r3f Canvas
      // we need to flatten styles or Canvas will not taking it
      style={StyleSheet.flatten(styles.canvas)}
      shadows
      camera={{ position: [0, 8, 15], fov: 60, near: 2 }}
      gl={{ antialias: true }}
    >
      <SplashSceneElements />
      {/* <Stats /> */}
    </Scene>
  )
}

const styles = StyleSheet.create({
  canvas: { backgroundColor: 'black', flex: 1, flexBasis: '100%', position: 'absolute' },
})

export default SplashScene
